import { useQuery } from 'react-query';

import { MindsightAuthSystemApi } from '../api/mindsightAuthSystem';

export const useAuthToggles = (authUrl: string) =>
  useQuery(['auth_toggles'], () => MindsightAuthSystemApi.getAuthToggles(authUrl), {
    enabled: !!authUrl,
  });
